import type { HelpFile } from '../../types/help'
import { ScriptInboundConfigCardTestIds } from '../../../testids/ScriptInboundConfigCardTestIds'

export const scriptInboundConfigCardHelp: HelpFile = {
  docPage: '/docs/connectors/script-connector',
  texts: {
    [ScriptInboundConfigCardTestIds.scriptInboundConfigCard]:
      'Configuration for an inbound script-based connector — defines how the system fetches identities and accounts from the script endpoint.',
    [ScriptInboundConfigCardTestIds.scriptInboundConfigCardError]:
      'The inbound script configuration could not be loaded; the connector will not run until the error is resolved.',
    [ScriptInboundConfigCardTestIds.scriptInboundConfigCardLoading]: null,
    [ScriptInboundConfigCardTestIds.cardTitleScriptInboundConfig]: null,
    [ScriptInboundConfigCardTestIds.cardTitleScriptInboundConfigError]: null,
    [ScriptInboundConfigCardTestIds.cardTitleScriptInboundConfigLoading]: null,
    [ScriptInboundConfigCardTestIds.btnCreateScriptConfig]:
      'Create the initial inbound configuration for this script connector.',
    [ScriptInboundConfigCardTestIds.btnEditScriptConfig]:
      'Edit the inbound script configuration; changes apply on the next inbound run.',
    [ScriptInboundConfigCardTestIds.btnValidateScript]:
      'Dry-run call against the script endpoint to validate configuration without making changes.',
    [ScriptInboundConfigCardTestIds.inputScriptApiKeyHeader]:
      'HTTP header name used to send the API key (for example, X-API-Key).',
    [ScriptInboundConfigCardTestIds.inputScriptApiKeySecretRef]:
      'Reference to the secret store entry that holds the API key value.',
    [ScriptInboundConfigCardTestIds.inputScriptBaseUrl]:
      'Base URL of the script endpoint that the connector calls.',
    [ScriptInboundConfigCardTestIds.inputScriptClientSecretRef]:
      'Reference to the OAuth2 client secret used by the script connector.',
    [ScriptInboundConfigCardTestIds.inputScriptPasswordSecretRef]:
      'Reference to the password secret used by the script connector.',
    [ScriptInboundConfigCardTestIds.inputScriptConnectTimeout]:
      'Seconds to wait for a TCP connection to the script endpoint before failing.',
    [ScriptInboundConfigCardTestIds.inputScriptReadTimeout]:
      'Seconds to wait for a response after the connection is established.',
    [ScriptInboundConfigCardTestIds.inputScriptTokenSecretRef]:
      'Reference to the secret store entry that holds the bearer token value.',
    [ScriptInboundConfigCardTestIds.selectScriptAuthType]:
      'Authentication mechanism used when calling the script endpoint (none, API key, or bearer token).',
  },
}
